import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css/animate.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '../css/style.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBullseye,
  faEye,
  faScaleBalanced,
  faChartLine,
  faClockRotateLeft,
  faCrosshairs,
  faBolt,
  faRobot
} from '@fortawesome/free-solid-svg-icons';

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animatedCounters: false
    };
  }

  componentDidMount() {
    // Trigger counter animation on scroll
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const statsSection = document.getElementById('stats-section');
    if (statsSection && !this.state.animatedCounters) {
      const rect = statsSection.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        this.setState({ animatedCounters: true });
        this.animateCounters();
      }
    }
  }

  animateCounters = () => {
    const counters = document.querySelectorAll('.counter-number');
    counters.forEach(counter => {
      const target = parseInt(counter.getAttribute('data-target'));
      const increment = target / 100;
      let current = 0;
      
      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          counter.textContent = target + (counter.getAttribute('data-suffix') || '');
          clearInterval(timer);
        } else {
          counter.textContent = Math.floor(current) + (counter.getAttribute('data-suffix') || '');
        }
      }, 20);
    });
  }

  render() {
    return (
      <div>
        
        <section className="general-banner">
          <div className="container">
            <div className="general-content">
              <h1 className="hero-title orbitron">About Us</h1>
              <p className="hero-subtitle">Leading the future of intelligent security solutions</p>
            </div>
          </div>
        </section>

        {/* Company Overview Section */}
        <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h2 className="display-5 fw-bold mb-4 orbitron">Protecting What Matters Most</h2>
                <p className="lead mb-4" style={{ color: 'var(--text-secondary)' }}>
                  Since our founding, Sterling Surveillance TechnologiesLtd. has been at the forefront of security innovation, 
                  combining traditional expertise with cutting-edge AI technology to deliver unparalleled protection solutions.
                </p>
                <p className="mb-4">
                  We understand that security isn't just about technology—it's about peace of mind. Our team of certified 
                  professionals works around the clock to ensure your assets, property, and people are protected with the 
                  highest level of security available today.
                </p>
                <div className="d-flex flex-wrap gap-2">
                  <span className="badge bg-primary px-3 py-2">AI-Powered</span>
                  <span className="badge bg-primary px-3 py-2">24/7 Monitoring</span>
                  <span className="badge bg-primary px-3 py-2">Expert Team</span>
                  <span className="badge bg-primary px-3 py-2">Certified</span>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="position-relative">
                  <div 
                    className="rounded-3 p-4"
                    style={{ 
                      backgroundColor: 'var(--box-dark-bg)',
                      border: '1px solid var(--secondary-dark)'
                    }}
                  >
                    <div className="text-center mb-3">
                      <div 
                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                        style={{ 
                          width: '80px', 
                          height: '80px', 
                          color: 'var(--icons-color)',
                      fontSize: '3rem'
                        }}
                      >
                        <FontAwesomeIcon icon={faRobot} />
                      </div>
                      <h4 className="orbitron">Advanced AI Integration</h4>
                      <p style={{ color: 'var(--text-secondary)' }}>
                        Our proprietary AI algorithms analyze patterns, detect anomalies, and provide 
                        intelligent threat assessment in real-time.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission, Vision, Values */}
        <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faBullseye} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Mission</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    To provide innovative, AI-driven security solutions that protect businesses and communities 
                    while setting new standards for reliability and effectiveness in the security industry.
                  </p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Vision</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    To be the global leader in intelligent security systems, creating a safer world through 
                    the seamless integration of human expertise and artificial intelligence.
                  </p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
              <div className="col-lg-4 mb-4">
                <div 
                  className="h-100 p-4 rounded-3 text-center service-card"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                    style={{ 
                      width: '60px', 
                      height: '60px', 
                      color: 'var(--icons-color)',
                      fontSize: '3rem'
                    }}
                  >
                    <FontAwesomeIcon icon={faScaleBalanced} />
                  </div>
                  <h3 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Our Values</h3>
                  <p style={{ color: 'var(--text-secondary)' }}>
                    Excellence, integrity, innovation, and unwavering commitment to our clients' safety. 
                    We believe in transparency, continuous improvement, and building lasting partnerships.
                  </p>
                  <div className="triangle-bottomright-blue"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Statistics Section */}
        <section 
          id="stats-section"
          className="py-5" 
          style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}
        >
          <div className="container">
            <div className="row text-center">
              <div className="col-12 mb-5">
                <h2 className="display-5 fw-bold orbitron">Our Track Record</h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Numbers that speak to our commitment and success
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  <div 
                    className="counter-number display-4 fw-bold orbitron mb-2"
                    data-target="100"
                    data-suffix="+"
                    style={{ color: 'var(--accent-cyan)' }}
                  >
                    0+
                  </div>
                  <h5 className="orbitron">Clients Protected</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>Businesses trust us with their security</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  <div 
                    className="counter-number display-4 fw-bold orbitron mb-2"
                    data-target="99"
                    data-suffix="%"
                    style={{ color: 'var(--accent-blue)' }}
                  >
                    0%
                  </div>
                  <h5 className="orbitron">Uptime Guarantee</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>Reliable monitoring you can count on</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  <div 
                    className="counter-number display-4 fw-bold orbitron mb-2"
                    data-target="10"
                    data-suffix="+"
                    style={{ color: 'var(--icons-color)' }}
                  >
                    0+
                  </div>
                  <h5 className="orbitron">Years Experience</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>Proven expertise in security solutions</p>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 mb-4">
                <div className="text-center">
                  <div 
                    className="counter-number display-4 fw-bold orbitron mb-2"
                    data-target="24"
                    data-suffix="/7"
                    style={{ color: 'var(--accent-cyan)' }}
                  >
                    0/7
                  </div>
                  <h5 className="orbitron">Monitoring</h5>
                  <p style={{ color: 'var(--text-secondary)' }}>Round-the-clock security coverage</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* AI Technology Section */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div 
                      className="p-3 rounded-3 text-center h-100"
                      style={{ backgroundColor: 'var(--box-dark-bg)' }}
                    >
                      <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faChartLine} /></div>
                      <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Smart Analytics</h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        AI-powered behavioral analysis and threat detection
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div 
                      className="p-3 rounded-3 text-center h-100"
                      style={{ backgroundColor: 'var(--box-dark-bg)' }}
                    >
                      <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faClockRotateLeft} /></div>
                      <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Real-time Monitoring</h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        Continuous surveillance with instant alerts
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div 
                      className="p-3 rounded-3 text-center h-100"
                      style={{ backgroundColor: 'var(--box-dark-bg)' }}
                    >
                      <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faCrosshairs} /></div>
                      <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Precision Detection</h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        Advanced algorithms for accurate threat identification
                      </small>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div 
                      className="p-3 rounded-3 text-center h-100"
                      style={{ backgroundColor: 'var(--box-dark-bg)' }}
                    >
                      <div className="mb-2" style={{ fontSize: '2rem' }}><FontAwesomeIcon icon={faBolt} /></div>
                      <h6 className="orbitron" style={{ color: 'var(--text-primary)' }}>Rapid Response</h6>
                      <small style={{ color: 'var(--text-secondary)' }}>
                        Automated emergency protocols and notifications
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <h2 className="display-5 fw-bold mb-4 orbitron" style={{ color: 'var(--text-primary)' }}>
                  AI-Powered Security Innovation
                </h2>
                <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
                  Our proprietary artificial intelligence technology revolutionizes traditional security monitoring. 
                  By leveraging machine learning algorithms and advanced pattern recognition, we deliver security 
                  solutions that are not just reactive, but predictive.
                </p>
                <div className="mb-4">
                  <h5 className="orbitron mb-3" style={{ color: 'var(--text-primary)' }}>Key AI Features:</h5>
                  <ul style={{ color: 'var(--text-secondary)' }}>
                    <li className="mb-2">Facial recognition and access control</li>
                    <li className="mb-2">Anomaly detection and behavioral analysis</li>
                    <li className="mb-2">Predictive threat assessment</li>
                    <li className="mb-2">Automated incident response</li>
                    <li className="mb-2">Integration with existing security infrastructure</li>
                  </ul>
                </div>
                <button className="btn btn-primary btn-lg">
                  Learn More About Our AI Technology
                </button>
              </div>
            </div>
          </div>
        </section> */}

        {/* Team Section */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)', color: 'var(--text-primary)' }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="display-5 fw-bold orbitron">Meet Our Leadership Team</h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Experienced professionals dedicated to your security
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 mb-4">
                <div 
                  className="text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      backgroundColor: 'var(--icons-color)',
                      fontSize: '2.5rem'
                    }}
                  >
                    👨‍💼
                  </div>
                  <h5 className="orbitron mb-2">John Sterling</h5>
                  <p className="text-muted mb-2">CEO & Founder</p>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                    15+ years in security industry with expertise in AI integration and business development.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div 
                  className="text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      backgroundColor: 'var(--accent-cyan)',
                      fontSize: '2.5rem'
                    }}
                  >
                    👩‍💻
                  </div>
                  <h5 className="orbitron mb-2">Dr. Sarah Chen</h5>
                  <p className="text-muted mb-2">CTO & AI Director</p>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                    PhD in Computer Science, specializing in machine learning and computer vision technologies.
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 mb-4">
                <div 
                  className="text-center p-4 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div 
                    className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '100px', 
                      height: '100px', 
                      backgroundColor: 'var(--accent-blue)',
                      fontSize: '2.5rem'
                    }}
                  >
                    👨‍🔧
                  </div>
                  <h5 className="orbitron mb-2">Mike Rodriguez</h5>
                  <p className="text-muted mb-2">Head of Operations</p>
                  <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
                    Former law enforcement with 20+ years experience in security operations and emergency response.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Certifications & Awards */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--secondary-dark)' }}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <h2 className="display-5 fw-bold orbitron" style={{ color: 'var(--text-primary)' }}>
                  Certifications & Recognition
                </h2>
                <p className="lead" style={{ color: 'var(--text-secondary)' }}>
                  Industry-recognized standards and achievements
                </p>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-2 col-md-4 col-6 mb-4">
                <div 
                  className="text-center p-3 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="mb-2" style={{ fontSize: '2rem' }}>🏆</div>
                  <small className="orbitron" style={{ color: 'var(--text-primary)' }}>ISO 27001</small>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-6 mb-4">
                <div 
                  className="text-center p-3 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="mb-2" style={{ fontSize: '2rem' }}>🛡️</div>
                  <small className="orbitron" style={{ color: 'var(--text-primary)' }}>SOC 2 Type II</small>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-6 mb-4">
                <div 
                  className="text-center p-3 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="mb-2" style={{ fontSize: '2rem' }}>⭐</div>
                  <small className="orbitron" style={{ color: 'var(--text-primary)' }}>UL Listed</small>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-6 mb-4">
                <div 
                  className="text-center p-3 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="mb-2" style={{ fontSize: '2rem' }}>🎖️</div>
                  <small className="orbitron" style={{ color: 'var(--text-primary)' }}>ASIS Certified</small>
                </div>
              </div>
              <div className="col-lg-2 col-md-4 col-6 mb-4">
                <div 
                  className="text-center p-3 rounded-3 h-100"
                  style={{ backgroundColor: 'var(--box-dark-bg)' }}
                >
                  <div className="mb-2" style={{ fontSize: '2rem' }}>📋</div>
                  <small className="orbitron" style={{ color: 'var(--text-primary)' }}>NIST Framework</small>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        {/* Call to Action */}
        {/* <section className="py-5" style={{ backgroundColor: 'var(--primary-dark)' }}>
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <h2 className="display-5 fw-bold mb-4 orbitron" style={{ color: 'var(--text-primary)' }}>
                  Ready to Secure Your Future?
                </h2>
                <p className="lead mb-4" style={{ color: 'var(--text-secondary)' }}>
                  Join hundreds of satisfied clients who trust Sterling Protection Services with their security needs. 
                  Contact us today for a personalized consultation and discover how our AI-powered solutions can protect what matters most to you.
                </p>
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
                  <button className="btn btn-primary btn-lg px-4">
                    Get Free Consultation
                  </button>
                  <button className="btn btn-outline-light btn-lg px-4">
                    View Our Services
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        
      </div>
    );
  }
}

export default About;